var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE2Office(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 3.63L3 25.89V69h70V25.9L38 3.63zM69 65H7V28.08L38 8l31 20.08V65zM34.07 20h7.86A3.06 3.06 0 0145 23.07V40H31V23.07A3.06 3.06 0 0134.07 20zM27 43h22v-5.5a1.5 1.5 0 113 0V46H39v6h5.62l3.53 8h-3.28l-2.21-5H39v5h-3v-5h-3.58l-2.19 5H27l3.51-8H36v-6H24v-8.5a1.5 1.5 0 113 0V43z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E2_Office.6b99fce7.svg";
export { SvgE2Office as ReactComponent };